import { cn } from '@/lib/cn'
import { CheckCircleIcon } from '@heroicons/react/24/solid'

interface CompletenessBarProps {
  percentage: number
  sections: Array<{ name: string; filled: boolean }>
}

export function CompletenessBar({ percentage, sections }: CompletenessBarProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-neutral-700">Complétude de la saisie</span>
        <span className={cn(
          'text-sm font-bold',
          percentage >= 80 ? 'text-success-600' : percentage >= 50 ? 'text-warning-600' : 'text-error-600'
        )}>
          {percentage}%
        </span>
      </div>
      <div className="h-2 bg-neutral-200 rounded-full overflow-hidden">
        <div
          className={cn(
            'h-full rounded-full transition-all duration-500',
            percentage >= 80 ? 'bg-success-500' : percentage >= 50 ? 'bg-warning-500' : 'bg-error-500'
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="flex flex-wrap gap-2 mt-1">
        {sections.map((s) => (
          <span key={s.name} className="inline-flex items-center gap-1 text-xs text-neutral-500">
            <CheckCircleIcon className={cn('w-3.5 h-3.5', s.filled ? 'text-success-500' : 'text-neutral-300')} />
            {s.name}
          </span>
        ))}
      </div>
    </div>
  )
}
